import { Skeleton } from 'antd'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

import { useStore } from 'store/useStore'
import { Text } from 'components/uiKit'
import { thousandsWhiteSpacing } from 'utils/formatting/thousandsWhiteSpacing/thousandsWhiteSpacing'
import { useAsyncEffect } from 'utils/hooks/useAsyncEffect'
import { Country, CurrencyFromCountry } from 'shared/types/types'

import { OrderLocationViewModel } from '../../stores/models/OrderLocationViewModel'

type SubsidyProps = {
  tariff: number
  location: OrderLocationViewModel
  country: Country
}

export const Subsidy = observer(({ tariff, location, country }: SubsidyProps) => {
  const { viewOrderUiStore: uiStore } = useStore()

  const [loading, setLoading] = useState(false)

  const subsidyItem = location.subsidyInfo.find((subsidy) => location.subsidyHexTypeItem?.value === subsidy.subsidyType)

  useAsyncEffect(async () => {
    if (tariff) {
      setLoading(true)

      await location.getSubsidy(tariff)

      // Меняю subsidyTypeItem в initialState, так как субсидия приходит с бека после первичной инициализации
      if (uiStore.initialState) {
        const initialState = uiStore.initialState
        initialState.subsidyTypeItem = location.subsidyHexTypeItem
        uiStore.setInitialState(initialState)
      }

      setLoading(false)
    }
  }, [tariff])

  return (
    <>
      {loading ? (
        <Skeleton.Input active={true} size="small" />
      ) : (
        subsidyItem && (
          <Text>
            {location.getSubsidyItem(country)?.label}, {thousandsWhiteSpacing(subsidyItem.subsidy)}{' '}
            {CurrencyFromCountry[country]}
          </Text>
        )
      )}
    </>
  )
})
